import React from 'react'
import DocumentTitle from 'react-document-title'
import { config } from 'config'

module.exports = React.createClass({
  propTypes() {
    return {
      route: React.PropTypes.object,
    }
  },
  render() {
    const post = this.props.route.page.data

    return (
      <DocumentTitle title={`${config.siteTitle}`}>
        <div className="markdown">
          <div dangerouslySetInnerHTML={{ __html: post.body }} />
        </div>
      </DocumentTitle>
    )
  },
})



/** WEBPACK FOOTER **
 ** ../wrappers/md.jsx
 **/